import React, { useEffect, useRef, useState } from 'react';
import { t } from 'i18next';
import Compressor from 'compressorjs';
import ImageGallery from 'react-image-gallery';
import ReactImageGallery from 'react-image-gallery';
import {
    Box,
    Button,
    Flex,
    HStack,
    Icon,
    IconButton,
    Input
} from '@chakra-ui/react';

import { LandClass, RoleClass } from '../../../core/land';
import { AnimalClass } from '../../../core/animal';

import { PageCard, PageCardFooter } from './pageCard';
import { DeleteIcon } from '@chakra-ui/icons';
import {
    AiOutlineFullscreen,
    AiFillHeart,
    AiOutlineHeart
} from 'react-icons/ai';

export default function ImageCard(props: {
    animal?: AnimalClass;
    land: LandClass;
    service: any;
    role: RoleClass;
    onUpload?: Function;
}): React.ReactElement {
    const imageRef = useRef<ReactImageGallery>();

    const [data, setData] = useState<LandClass | AnimalClass>();
    const [images, setImages] = useState<any[]>([]);
    const [currentImage, setCurrentImage] = useState<string>();
    const [isUploading, setIsUploading] = useState<boolean>(false);

    const saveFavImage = async () => {
        if (data) {
            data.imageFav = currentImage;
            const saved = await props.service.save(data);
            props.onUpload && props.onUpload();
        }
    };

    const uploadPhoto = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target?.files && data) {
            setIsUploading(true);
            new Compressor(e.target.files[0], {
                quality: 0.8,
                maxWidth: 1920,
                maxHeight: 1920,
                async success(result) {
                    await props.service.uploadFile(result, data);
                    props.onUpload && props.onUpload();
                    setIsUploading(false);
                },
                error(err) {
                    console.error(err.message);
                    setIsUploading(false);
                }
            });
        }
    };

    const deletePhoto = async () => {
        await props.service.deleteFile(currentImage, data);
        props.onUpload && props.onUpload();
    };

    useEffect(() => {
        var d = props.animal
            ? (props.animal as AnimalClass)
            : (props.land as LandClass);
        setData(d);
        const images = d?.getPictures().map((i) => {
            return {
                original: i,
                originalHeight: 50
            };
        });
        images && setImages(images);
        images && !currentImage && setCurrentImage(images[0].original);
    }, [props.land]);

    return data ? (
        <PageCard id='imageCard'>
            <Box mx={{ base: -3, md: -7 }} mt={{ base: -2, md: -5 }}>
                <ImageGallery
                    ref={imageRef as any}
                    autoPlay={false}
                    showPlayButton={false}
                    showThumbnails={false}
                    showFullscreenButton={false}
                    items={images}
                    onSlide={(e) => {
                        const index =
                            imageRef.current?.getCurrentIndex() as number;
                        const current = images[index];
                        setCurrentImage(current.original);
                    }}
                />
            </Box>

            {!props.role?.isReader() ? (
                <PageCardFooter>
                    <Flex
                        justify={
                            images.length > 1 && props.role?.isOwner()
                                ? 'space-between'
                                : 'end'
                        }
                        w='full'
                    >
                        {images.length > 1 && props.role?.isOwner() && (
                            <IconButton
                                size={'sm'}
                                colorScheme='red'
                                variant='outline'
                                aria-label='Delete'
                                icon={<Icon as={DeleteIcon} />}
                                onClick={deletePhoto}
                            />
                        )}
                        <HStack>
                            <IconButton
                                size={'sm'}
                                colorScheme='green'
                                variant='outline'
                                aria-label='fav'
                                onClick={() => imageRef.current?.fullScreen()}
                                icon={<Icon as={AiOutlineFullscreen} />}
                            />
                            {images.length > 1 && (
                                <IconButton
                                    size={'sm'}
                                    colorScheme='green'
                                    variant='outline'
                                    aria-label='fav'
                                    onClick={saveFavImage}
                                    icon={
                                        <Icon
                                            as={
                                                data?.imageFav === currentImage
                                                    ? AiFillHeart
                                                    : AiOutlineHeart
                                            }
                                        />
                                    }
                                />
                            )}
                            <Button
                                as='label'
                                size='sm'
                                colorScheme='green'
                                variant='outline'
                                isLoading={isUploading}
                            >
                                {t('form.addPhotos') as string}
                                <Input
                                    type='file'
                                    name='images'
                                    defaultValue=''
                                    accept='image/*'
                                    display={'none'}
                                    onChange={uploadPhoto}
                                />
                            </Button>
                        </HStack>
                    </Flex>
                </PageCardFooter>
            ) : (
                <PageCardFooter>
                    <IconButton
                        size={'sm'}
                        colorScheme='green'
                        variant='outline'
                        aria-label='fav'
                        onClick={() => imageRef.current?.fullScreen()}
                        icon={<Icon as={AiOutlineFullscreen} />}
                    />
                </PageCardFooter>
            )}
        </PageCard>
    ) : (
        <></>
    );
}
